'use strict';

angular.module('clientDashboardApp.common').directive('copyToClipboard', function () {

  console.log('copy-to-clipboard directive')

  return {
    restrict: 'A',
    template: `
        <span class='copy-to-clipboard fas fa-clipboard' ng-click='vm.copyToClipboard()' uib-tooltip='Copy to clipboard' tooltip-append-to-body='true' tooltip-placement='top' style="{{copyToClipboardStyle}}"></span>
        <textarea id='clipboard-content' class='clipboard-content'></textarea>
    `,
    scope: {
      snippet: "=",
      copyToClipboardStyle: "="
    },
    controller: CopyToClipboardCtrl,
    controllerAs: 'vm'
  }

});

CopyToClipboardCtrl.$inject = ['$scope'];

function CopyToClipboardCtrl($scope) {
  var vm = this;
  function initClipboardEvents() {
    vm.clipboardEventsReady = true;
    _.each(['cut', 'copy', 'paste'], function (event) {
      document.addEventListener(event, function (e) {
      });
    });
  }

  vm.copyToClipboard = function () {
    if (!vm.clipboardEventsReady) {
      initClipboardEvents();
    }

    var $target = $('#clipboard-content');
    $target.val($scope.snippet);
    $target.select();

    vm.enableCopy = document.queryCommandSupported('copy');

    if (vm.enableCopy) {
      try {
        var successful = document.execCommand('copy');
      } catch (err) {
      }
    }

  }

}


